import styled from "styled-components";

import { SecondaryButton } from "uikit";

export const ManageBankAccountButton = styled(SecondaryButton)`
  width: auto;
  min-width: auto;
`;
